import type * as React from 'react';

import * as Styled from './button.styles';
const { sizes, variants } = Styled;

export type ButtonSizes = keyof typeof sizes;
export type ButtonVariants = keyof typeof variants;

type CommonProps = {
  /** Label of the button, should be text, icons are handled separately */
  children?: React.ReactNode;
  /** Add custom CSS */
  className?: string;
  /** Disable the Button */
  disabled?: boolean;
  /** Activate text truncation. This needs a fixed button width or flex container around the button to work */
  ellipsis?: boolean;
  /** Hand over an icon component for the button */
  icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  /** Access the DOM node */
  innerRef?: React.RefObject<HTMLElement>;
  /** Loading state of the button */
  loading?: boolean;
  /** @callback */
  onClick?: (e: MouseEvent) => void;
  /** The size on mobile screens or larger */
  size?: ButtonSizes;
  /** The size on tablet screens or larger */
  sizeConfined?: ButtonSizes;
  /** The size on desktop screens or larger */
  sizeWide?: ButtonSizes;
  /** The variant of button */
  variant?: ButtonVariants;
};

type ButtonHtmlProps = React.ComponentProps<typeof Styled.Button> &
  CommonProps & {
    href?: never;
    to?: never;
  };

type ButtonRouterLinkProps = React.ComponentProps<typeof Styled.RouterButton> &
  CommonProps & {
    disabled?: never;
    type?: never;
  };

export type ButtonProps = ButtonHtmlProps | ButtonRouterLinkProps;
